import React, { Component } from 'react';
import { Card, Header, Button, Image, Icon, Divider, Feed } from 'semantic-ui-react'
import * as moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link } from 'react-router-dom';
import * as FbUtils from '../../../Utilities/FireBaseUtils'
import { base, getOrderKey, logDashboardAction } from '../../../config/constants';
import NextStatusButton from './NextStatusButton'
import Status from '../../../config/OrderStatusConstants.js'
import ImageUploader from '../../newSite/ImageUploader'
import {
    GetTimeAgo, OrderStatus, ShowOrderDetailsSection, VerifyOrderButton,
    CustomerRejectDesigns, UploadDesign, ViewOrderLink, EditOrderLink,
    UpdateComment, OrderUpdateFeed, ShowLastUpdate, ShowType, SendToFindShirt, SendToConfirmOrder,
    MarkOrderAsDeliveredComponent, LostButton, ItemCostUI
} from './DashboardParts'
import Kimoto from './Kimotos/Kimoto'
import * as Utils from '../../../Utilities/Utils'
// import DeliveryPerson from './DeliveryPerson'
// import CustomerPick from './CustomerPickup/CustomerPickup'

//DEPOSIT
import RequestDeposit from './Deposits/RequestDeposit'
import DepositConfirmation from './Deposits/DepositConfirmation'


import { UpdateStatus } from './UpdateStatus/UpdateStatus';
import ViewSingleOrders from './ViewSingleOrders/ViewSingleOrders';
import MakeOrderLost from './Lost/MakeOrderLost';
import DateRequired from './DateRequired/DateRequired';
import DepositReminder from './DespositReminder/DepositReminder';
import ConfirmOrderReminder from './ConfirmOrderReminder/ConfirmOrderReminder';
import UpdateCountry from './Countries/UpdateCountry';
import PickDesigner from './PickDesigner/PickDesigner';
import SetOrderType from './SetOrderType/SetOrderType';
import DuplicateOrderMistake from './DuplicateOrder/DuplicateOrderMistake';
import SetUserDetails from './UserDetails/SetUserDetails';
import DeliveryGuySms from './DeliveryGuySms/DeliveryGuySms';
import WhatsappButtons from './Whatsapp/WhatsappButtons';
import UpdateStatusAlgolia from './UpdateStatus/UpdateStatusAlgolia';
import DuplicateOrder from './DuplicateOrder/DuplicateOrder';
import ReplacementOrder from './ReplacementOrder/ReplacementOrder';
import Feedback from './Feedback/Feedback';
import AlogoliaOrderUpdateFeed from './algoliaDashboard/AlogoliaOrderUpdateFeed'
import AlgoliaViewSingleOrders from './algoliaDashboard/AlgoliaViewSingleOrders';
import { updateAlgoliaUpdateOnArchivedOrder } from './algoliaDashboard/AlgoliaMiscUtils'
import AddSalesPerson from './Sales/AddSalesPerson';
import CheckOrderProjectInfo from './LargeProjects/CheckOrderProjectInfo'
import DesignBackup from './DesignBackup/DesignBackup';
import WhatsappPermission from './Whatsapp/WhatsappPermission'
import WhatsappSendImage from './Whatsapp/WhatsappSendImage'
import WhatsappGotoConvo from './Whatsapp/WhatsappGotoConvo'
import WhatsappClntRevSendDepReq from './Whatsapp/WhatsappClntRevSendDepReq'
import WhatsappDepReqSendLost from './Whatsapp/WhatsappDepReqSendLost'
import MarkAutoSendDesign from './Whatsapp/MarkAutoSendDesign'
import WhatsappUpdatePhone from './Whatsapp/WhatsappUpdatePhone'
import EnterShirtCost from './EnterShirtCost/EnterShirtCost'
import InHouseStockItem from './InHouseStockItems/InHouseStockItem';
import ViewItemOptionsInOrder from './LargeProjectOrderEntry/ViewItemOptionsInOrder';
import MarkEmbroidery from './Sales/MarkEmbroidery';
import SetToOutForDelivery from './SetToOutForDelivery/SetToOutForDelivery';



{/* OrderCard */ }
export default class OrderCard extends Component {
    constructor(props) {
        super(props);

        //console.log(this.props);
        // console.log(" OrderCard - got user:" + JSON.stringify(this.props.user));

        this.state = {
            updateText: '',
            orderUpdates: [],
            orderUpdatesbase: [],
            viewOrderDetails: false,
            showUpdates: true,
            cranesNumber: '',
            showDesignImage: false,
            showUserImage: false
        }
    }



    componentDidMount() {
        // console.log("whatx777 ==== componentDidMount");
        // console.log("whatx772 algoliauser:" + JSON.stringify(this.props.algoliaUser))


        // console.log("upx7751 this.props.searchNow:" + this.props.searchNow);
        if (this.props.searchNow) {
            //console.log("upx7752 orderUpdates:" + this.props.order.order_num + " " + JSON.stringify(this.props.order.orderUpdates));

            if (this.props.order.orderUpdates) {
                this.setState({
                    orderUpdatesbase: this.props.order.orderUpdates
                })
            }


        } else {
            this.syncOrderUpdates();
        }



        //  console.log("aglx93: OrderCard componentDidMount props designers:" + JSON.stringify(this.props.designers, null, 3));

    }

    /**
    * FUNCTION WHEN NEW DESIGN IS UPLOADED
    */
    designUploadComplete = (uploadComplete, actualFileName, url) => {
        console.log("++++++++++:designUploadComplete");
        console.log("actualFileName:" + actualFileName);
        console.log("url:" + url);

        let updateEmail = this.props.user && this.props.user.email
            ? this.props.user.email
            : "testadmin@test.com"

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdate = {
            designImageUrl: url,
            designUpdated: now,
            design_lastUpdatedBy: this.props.user.email,
            lastUpdatedBy: this.props.user.email
        }


        
        FbUtils.updateOrder(this.props.order.key, orderUpdate);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName,
            imageUrl: url
        });
        // this.props.history.push('/newOrder/thankYou');

        //SEND IMAGE TO DESIGN IMAGE CHATIVEW
        //(firebaseSaveUrl, imageUrl, adminEmail){
        console.log("before calling addDesignToDesignChatView addDesignToDesignChatView");
        // addDesignToDesignChatView(this.props.order.key, url, this.props.user.email);

        let updateString = "uploaded_dsgn_dash " + this.props.user.email + " " + this.props.order.order_num + " " + url;
        logDashboardAction(updateString, this.props.user.email, this.props.order.order_num, "designUploadComplete");
    }


    updateCommentFormSubmit = () => {
        console.log("upx10 +++++++: updateCommentFormSubmit");
        console.log("upx12 this state updateText:" + this.state.updateText);
        console.log("upx13 this.props.order.key:" + this.props.order.key);
        console.log("upx131 this.props.order.objectID:" + this.props.order.objectID);
        console.log("upx131 this.props.searchNow):" + this.props.searchNow);
        //console.log("upx132 this.props.order):" + JSON.stringify(this.props.order,null,3));

        if (this.state.updateText.length > 2) {

            let userEmail = this.props.user && this.props.user.email ? this.props.user.email : 'unknown';

            // IF ITS AN ARCHIVED ORDER, FROM SEARCH NOW
            if (this.props.order.archived && this.props.order.objectID && this.props.searchNow) {
                console.log("upx 141 ITS AN ARCHIVED ORDER, FROM SEARCH NOW");
                console.log("upx14 its alogolia and ARCHIVED this.props.order.objectID exists and searchNow is true:" + this.props.order.objectID);

                updateAlgoliaUpdateOnArchivedOrder(this.props.order.objectID, this.state.updateText, userEmail);

                //FbUtils.insertUpdateText(this.props.order.objectID, this.state.updateText, userEmail);

                this.setState({
                    updateText: ""
                });

           // IF ITS NOT AN ARCHIVED ORDER AND FROM SEARCH NOW
           // } else if (this.props.order.objectID) {
            } else if (!this.props.order.archived && this.props.order.objectID && this.props.searchNow) {
                console.log("upx151 ITS NOT AN ARCHIVED ORDER AND FROM SEARCH NOW");
                console.log("upx15 its alogolia this.props.order.objectID exists:" + this.props.order.objectID);
                FbUtils.insertUpdateText(this.props.order.objectID, this.state.updateText, userEmail);
                this.setState({
                    updateText: ""
                });

            } else if (this.props.order.key) {
                console.log("upx16 its NORMAL this.props.order.key exists:" + this.props.order.key);
                FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, userEmail);
                this.setState({
                    updateText: ""
                });
            }

            if (this.props.searchNow) {
                console.log("upx17 updateCommentFormSubmit searchnow is true call refresh after time out.");

                setTimeout(this.props.setRefreshToTrue, 5000);
                setTimeout(this.props.setRefreshToFalse, 10000);

                // setTimeout(function() { this.props.setRefreshToTrue; }, 2000);
                // setTimeout(function() { this.props.setRefreshToFalse; }, 4000);
            }


            //FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, this.props.user);
            // FbUtils.insertUpdateText(this.props.order.key, this.state.updateText, userEmail);
            // this.setState({
            //     updateText: ""
            // });
            //UPDATE SERVER NIGGA!


        }
    }

    /**
     * IF CLINT REJECTS DESIGN
     */
    clientRejectDesign = () => {
        console.log("+++++++: clientRejectDesign");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.clnt_rejectd_dsgn,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
            // udpatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    handleTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            updateText: e.target.value
        })
    }

    handleCranseNumberTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            cranesNumber: e.target.value
        })
    }

    viewOrderDetailsToggle = () => {
        ///console.log("+++++viewOrderDetailsToggle");
        if (this.state.viewOrderDetails) {
            this.setState({ viewOrderDetails: false })
        } else {
            this.setState({ viewOrderDetails: true })
        }
    }

    showComments = () => {
        // console.log("+++++:showComments");
        // console.log("showUpdates:" + this.state.showUpdates);
        if (this.state.showUpdates) {
            console.log("this.state.showUpdate is true");
            this.setState({
                showUpdates: false
            })
        } else {
            console.log("this.state.showUpdate is false");
            this.syncOrderUpdates();
            this.setState({
                showUpdates: true
            })
        }
    }

    syncOrderUpdates = () => {

        let orderKey = this.props.order.key

        if (this.props.order.key) {
            // console.log("upx77 syncOrderUpdates its NORMAL this.props.order.key:" + this.props.order.key);
            orderKey = this.props.order.key

        } else if (this.props.order.objectID) {
            // console.log("upx771 its ALGOLIA this.props.order.objectID exists:" + this.props.order.objectID + " orderNum:" + this.props.order.order_num);
            orderKey = this.props.order.objectID
        }

        // console.log("upx773 orderKey is:" + orderKey)

        // console.log("upx774 componentDidMount query String:" + 'orders/' + orderKey + '/orderUpdates');

        base.syncState('orders/' + orderKey + '/orderUpdates', {
            context: this,
            state: 'orderUpdatesbase',
            asArray: true,
            queries: {
                orderByChild: 'status',
                limitToLast: 10
            }
        });

        // base.fetch('orders/' + this.props.order.key + '/orderUpdates', {
        //     context: this,
        //     state: 'orderUpdatesbase',
        //     asArray: false,
        //     queries: {
        //         orderByChild: 'status',
        //         limitToLast: 3
        //     },
        //     then(data) {
        //         console.log("fetch data:"+data);
        //         this.setState({
        //             orderUpdatesbase: data
        //         })
        //     }
        // });

    }

    markNumbersChecked = () => {
        console.log("++++++; markNumbersChecked");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            numberChecked: true,
            numberCheckedOn: now
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    updateCranesNumber = () => {
        console.log("++++++; updateCranesNumber");
        console.log("number:" + this.state.cranesNumber);

        let tempSingleNumber = false;

        /**
         * FOR SINGLE OR DOUBLE NUMBER
         */
        if (this.state.cranesNumber.length == 1) {
            tempSingleNumber = true;
        } else {
            tempSingleNumber = false;
        }

        //create orer update orbject
        let orderUpdates = {
            jerseyNumber: this.state.cranesNumber,
            jerseyNumberSingleNumber: tempSingleNumber
        }

        //SAVE FIRST AND LAST NUMBER. 
        if (this.state.cranesNumber.length > 1) {
            console.log("length is greater than 1");

            console.log("firstDigit:" + this.state.cranesNumber.charAt(0));
            console.log("secondDigit:" + this.state.cranesNumber.charAt(1));

            let tempJerseyNumberPosition = {
                firstDigit: this.state.cranesNumber.charAt(0),
                secondDigit: this.state.cranesNumber.charAt(1)
            };

            // orderUpdates.jerseyNumberPosition = jerseyNumberPosition;

            orderUpdates = {
                jerseyNumber: this.state.cranesNumber,
                jerseyNumberSingleNumber: tempSingleNumber,
                jerseyNumberPosition: tempJerseyNumberPosition
            }

        } else {
            console.log("length is less than 1");
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

    }


    makeOrderLost = () => {
        console.log("++++: makeOrderLost");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.lost,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }


        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        let updateString = this.props.user.email + " updated order " + this.props.order.order_num + " from " + this.props.order.status + " to " + Status.lost
        console.log("nxtb12 updateString:" + updateString);
        logDashboardAction(updateString, this.props.user.email, this.props.order.order_num, "updateStatus");
        console.log("nxtb13 updateString after logDashboardAction");

        let daysSince = Utils.GetDaysSinceOrderPlaced(this.props.order.dateNum);
        let eventProperties = {
            status: this.props.order.status,
            daySinceOrderPlaced: daysSince
        }

    }

    sendToFindShirt = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.find_shirt,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    /**
     * SEND TO CONFIRM ORDER
     */
    sendToConfirmOrder = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.confirm_order,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }

    /**
    * SEND TO CONFIRM ORDER
    */
    markAsDelivered = () => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.delivered,
            lastUpdated: now,
            lastUpdatedBy: this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);
    }



    /**
     * SHOW THE DESIGN IMAGE
     */
    showDesignImage = () => {

        if (this.state.showDesignImage) {
            this.setState({
                showDesignImage: false
            })
        } else {
            this.setState({
                showDesignImage: true
            })
        }
    }


    /**
    * SHOW USER IMAGE
    */
    showUserImage = () => {

        if (this.state.showUserImage) {
            this.setState({
                showUserImage: false
            })
        } else {
            this.setState({
                showUserImage: true
            })
        }
    }

    
    bringOrderFromArchives = () => {
        console.log("bax1 +++++++++++ bringOrderFromArchivesButton");
        console.log("bax12 order number:" + this.props.order.order_num);
        console.log("bax13 order key:" + this.props.order.key);
        FbUtils.bringOrderFromArchives(this.props.order, this.props.user.email);
    }

    render() {

        const currentDesignImagePreview = this.props.order.designImageUrl && this.state.showDesignImage
            // const currentDesignImagePreview = this.props.order.designImageUrl 
            ? (<Image src={this.props.order.designImageUrl} width='250' height='250' centered bordered shape='rounded' />)
            : (<p></p>)

        const showDesignImageButton = this.props.order.itemType !== 'football' && this.props.order.itemType !== 'cranes'
            ? <Button color='orange' onClick={this.showDesignImage}>Show Design</Button>
            : ''

        const userUploadedImage = this.props.order.imageUrl && this.state.showUserImage
            ? (<Image src={this.props.order.imageUrl} size='medium' centered bordered shape='rounded' />)
            : (<p></p>)

        // const showUserImageButton = this.props.order.itemType !== 'football' && this.props.order.itemType !== 'cranes'
        //     ? <Button color='blue' onClick={this.showUserImage}>Show Uploaded Image</Button>
        //     : ''

        // const shirtsPickedUp = this.props.order.shirtsPickedUp
        //     ? (<Card.Content extra>
        //         <Icon name='in cart' />
        //         SHIRTS PICKED UP
        //       </Card.Content>)
        //     : (<Card.Content extra>
        //         <Icon name='close' />
        //         NEED TO GET SHIRTS
        //       </Card.Content>)

        const orderType = this.props.order.itemType === 'cranes'
            ? <Header as='h4'>
                <Icon name='flag' />
                <Header.Content>
                    CRANES
                </Header.Content>
            </Header>
            : <Header as='h4'>
                <Icon name='shirtsinbulk' />
                <Header.Content>
                    NORMAL
              </Header.Content>
            </Header>

        // const archiveOrder = this.props.user && this.props.user.email !== undefined && this.props.user.email === "ivanmworozi@gmail.com"
        //     ? <ArchiveOrder
        //         authed={this.props.authed}
        //         user={this.props.user}
        //         orderId={this.props.order.key}
        //         order={this.props.order} />
        //     : ''

        // const UpdateStatusStuck = this.props.user && this.props.user.email !== undefined && (this.props.user.email === "ivanmworozi@gmail.com" || this.props.user.email === "deliveries@printboda.com")
        //     ? <UpdateStatus
        //         user={this.props.user}
        //         orderId={this.props.order.key}
        //         order={this.props.order}
        //         status={Status.stuck} />
        //     : ''

        // const UpdateStatusTotalLoss = this.props.user && this.props.user.email !== undefined && (this.props.user.email === "ivanmworozi@gmail.com" || this.props.user.email === "deliveries@printboda.com")
        //     ? <UpdateStatus
        //         user={this.props.user}
        //         orderId={this.props.order.key}
        //         order={this.props.order}
        //         status={Status.total_loss} />
        //     : ''

        /**
         * PUT ORDER IN REQUEST DEPOSIT STATUS
         */
        const requestDepositStatus = this.props.order.status !== Status.printing
            && this.props.order.status !== Status.deposit_request
            && this.props.order.status !== Status.delivered
            && this.props.order.status !== Status.out_delivery
            && this.props.order.status !== Status.packing
            && this.props.order.depositRequested !== 'paid'
            ? <div>
                <br />
                <UpdateStatus
                    user={this.props.user}
                    orderId={this.props.order.key}
                    order={this.props.order}
                    status={Status.deposit_request} />
            </div>
            : ''

        const depositConfirmation = <div>
            <br />
            <DepositConfirmation
                user={this.props.user}
                //orderId={this.props.order.key}
                order={this.props.order}
            //status={Status.deposit_request} 
            />
        </div>

        // const depositConfirmation = this.props.order.status !== Status.new
        //     //&& this.props.order.status !== Status.delivered
        //     // && this.props.order.status !== Status.out_delivery
        //     // && this.props.order.status !== Status.packing
        //     // && this.props.order.status !== Status.lost
        //     // && this.props.order.status !== Status.packing
        //     // && this.props.order.status !== Status.refused
        //     // && this.props.order.status !== Status.total_loss
        //     // && this.props.order.status !== Status.stuck
        //     ? <div>
        //         <br />
        //         <DepositConfirmation
        //             user={this.props.user}
        //             //orderId={this.props.order.key}
        //             order={this.props.order}
        //         //status={Status.deposit_request} 
        //         />
        //     </div>
        //     : ''

        /**
         * PUT ORDER IN DEPOSIT REQUESTED STATUS
         */
        const depositRequestedStatus = this.props.order.status === Status.deposit_request
            ? <div>
                <br />
                <UpdateStatus
                    user={this.props.user}
                    orderId={this.props.order.key}
                    order={this.props.order}
                    status={Status.deposit_requested} />
            </div>
            : ''

        /**
       * PUT ORDER IN START KIMOTO DESIGN
       */
        // const startKimotoDesign = this.props.order.itemType !== 'cranes'
        //     && this.props.order.itemType !== 'football'
        //     && this.props.order.status !== Status.depositRequested
        //     ? <div>
        //         <br />
        //         <UpdateStatus
        //             user={this.props.user}
        //             orderId={this.props.order.key}
        //             order={this.props.order}
        //             status={Status.start_dsng_kimoto} />
        //     </div>
        //     : ''

        /**
         * SEND ORDER TO CLIENT REJECTED
         */
        const sendToClientRejected = this.props.order.itemType !== 'cranes'
            && this.props.order.itemType !== 'football'
            && (this.props.order.status === Status.new_design_added || this.props.order.status === Status.clnt_chckng_dsgn)
            ? <div>
                <br />
                <UpdateStatus
                    user={this.props.user}
                    orderId={this.props.order.key}
                    order={this.props.order}
                    status={Status.clnt_rejectd_dsgn} />
            </div>
            : ''

        const enteredBy = this.props.order.enteredBy
            ? "Entrd by:" + this.props.order.enteredBy
            : ''




        const confirmReminderSms = this.props.order.status === Status.confirm_order
            && (this.props.order.itemType === 'football' || this.props.order.itemType === 'cranes')
            ? <ConfirmOrderReminder
                user={this.props.user}
                orderId={this.props.order.key}
                order={this.props.order}
                mainOrder={this.props.order} />
            : ''


        // const orderCallAction = this.props.order.status === Status.printing
        //     || this.props.order.status === Status.packing
        //     || this.props.order.status === Status.out_delivery
        //     ? <OrderCallAction
        //         order={this.props.order} />
        //     : ''

        //const updateStatusToFollowUp = this.props.user && this.props.user.email === "ivanmworozi@gmail.com"
        // const updateStatusToFollowUp = this.props.user && this.props.user.email
        //     ? <UpdateStatus
        //         user={this.props.user}
        //         orderId={this.props.order.key}
        //         order={this.props.order}
        //         status={Status.follow_up} />
        //     : ''


        const updateCountryUI = this.props.user && this.props.user.email === "ivanmworozi@gmail.com"
            ? <div><br /><UpdateCountry
                user={this.props.user}
                orderId={this.props.order.key} /></div>
            : ''

        const setOrderTypeUI = this.props.user && this.props.user.email === "ivanmworozi@gmail.com"
            ? <SetOrderType order={this.props.order} user={this.props.user} />
            : ''

        const setSalesPerson = this.props.order.algoliaArchived
            ? <h4> NEED TO BRING BACK FROM ARCHIVES TO CHANGE SALES PERSON</h4>
            : <AddSalesPerson order={this.props.order} user={this.props.user} salesPeopleChoices={this.props.salesPeopleChoices} />



        //const deleteDuplicateOrderUI = this.props.user && this.props.user.email === "ivanmworozi@gmail.com"
        const deleteDuplicateOrderUI = this.props.user && this.props.user.email && this.props.algoliaUser && this.props.algoliaUser.deleteOrder
            ? <DuplicateOrderMistake order={this.props.order} user={this.props.user} />
            : ''

        // const setUserDetails = this.props.user && this.props.user.email === "ivanmworozi@gmail.com"
        //     ? <SetUserDetails order={this.props.order} user={this.props.user} />
        //     : ''

        // const sendDeliveryGuySMS = this.props.order.status === Status.out_delivery
        const sendDeliveryGuySMS = (this.props.order.status !== Status.new && this.props.order.status !== Status.delivered)
            && (this.props.user.email === "ivanmworozi@gmail.com"
                || this.props.user.email === "deliveries@printboda.com"
                || this.props.user.email === "alijibril2@gmail.com")
            ? <DeliveryGuySms
                user={this.props.user}
                orderId={this.props.order.key}
                order={this.props.order}
                mainOrder={this.props.order}
                deliveryPersonChoices={this.props.deliveryPersonChoices} />
            : ''

        const rejectedReason = this.props.order.rejectedReason && this.props.order.status == Status.clnt_rejectd_dsgn
            ? <div>
                <h8></h8>
                <Card>
                    <Card.Content>
                        <Card.Description>REJECT REASON</Card.Description>
                        <Card.Header>{this.props.order.rejectedReason}</Card.Header>
                        <Card.Description>{moment(this.props.order.rejectedTime).fromNow()}</Card.Description>

                    </Card.Content>
                </Card>
            </div>
            : ''

        const whatsAppButtons = this.props.algoliaUser && this.props.algoliaUser.whatsapp_reply
            ? <WhatsappButtons order={this.props.order} />
            : ''


        const feedbackUI = this.props.order.status == Status.delivered && !this.props.order.feedback_lastUpdated
            ? <Feedback
                user={this.props.user}
                //orderId={this.props.order.key}
                orderId={getOrderKey(this.props.order)}
                order={this.props.order}
                mainOrder={this.props.order}
                user={this.props.user} />
            : ''


        const feedbackUIStuff = this.props.order.feedback_lastUpdated
            ? <div>
                <Divider horizontal>{'FEEDBACK'}</Divider>
                <Card>
                    <Card.Content>
                        <Card.Description>FEEDBACK</Card.Description>
                        <Card.Description>Get what they want?: {this.props.order.feedback_happyWith}</Card.Description>
                        <Card.Description>Would they recommend?: {this.props.order.feedback_recommend}</Card.Description>
                        <Card.Description>Will they Order Again?: {this.props.order.feedback_orderAgain}</Card.Description>
                        <Card.Description>Improvement: {this.props.order.feedback_improvement}</Card.Description>

                    </Card.Content>
                </Card>
            </div>
            : ''



        const searchNowOrderUpdates = this.props.searchNow
            ? <div>
                <Divider horizontal>{'ORDER UPDATES'}</Divider>
                <AlogoliaOrderUpdateFeed
                    order={this.props.order}
                    searchNow={this.props.searchNow}
                    showUpdates={this.state.showUpdates}
                    showComments={this.showComments}
                    setRefreshToFalse={this.props.setRefreshToFalse}
                    setRefreshToTrue={this.props.setRefreshToTrue}
                    refresh={this.props.refresh}
                    awaitingRefresh={this.props.awaitingRefresh} />
            </div>
            : <div>
                <Divider horizontal>{'ORDER UPDATES'}</Divider>
                <OrderUpdateFeed
                    order={this.props.order}
                    searchNow={this.props.searchNow}
                    showUpdates={this.state.showUpdates}
                    orderUpdates={this.state.orderUpdatesbase}
                    syncOrderUpdates={this.syncOrderUpdates}
                    showComments={this.showComments} />
            </div>

        const viewSingleOrdersUi = this.props.searchNow
            ? <AlgoliaViewSingleOrders
                mainOrder={this.props.order}
                user={this.props.user}
                viewOrderDetails={this.state.viewOrderDetails}
                viewOrderDetailsToggle={this.viewOrderDetailsToggle}
                searchNow={true} />
            : <ViewSingleOrders
                mainOrder={this.props.order}
                user={this.props.user}
                viewOrderDetails={this.state.viewOrderDetails}
                viewOrderDetailsToggle={this.viewOrderDetailsToggle} />

        //     const searchNowOrderUpdates = this.props.order.orderUpdates 
        //      ? this.props.order.orderUpdates.map((update) =>

        //      <Feed.Event>
        //          <Feed.Content>
        //              <Feed.Summary>
        //                  {update.updateText}
        //              </Feed.Summary>
        //              <Feed.Meta>
        //                  <Feed.Like>
        //                      {update.time}
        //                  </Feed.Like>
        //                  <ShowEmail updatedBy={update.updatedBy}
        //                   />
        //              </Feed.Meta>
        //          </Feed.Content>
        //      </Feed.Event>
        //  ):''

        const bringOrderFromArchivesButton = this.props.fromArchives || this.props.order.algoliaArchived || this.props.order.archived
            ? <Button color='red' onClick={this.bringOrderFromArchives}>BRING FROM ARCHIVES</Button>
            : ''

        const archivedOrder = this.props.searchNow && (this.props.order.algoliaArchived || this.props.order.archived)
            ? <h3> *** ARCHIVED ORDER *** </h3>
            : ''

        const updateOrderUI = this.props.order.archived
            ? ''
            : < UpdateComment
                updateCommentFormSubmit={this.updateCommentFormSubmit}
                textValue={this.state.updateText}
                handleTextChange={this.handleTextChange} />

        const updateStatusAlgolia = (this.props.searchNow) && (this.props.order.archived || this.props.order.algoliaArchived)
            ? ''
            : <UpdateStatusAlgolia
                user={this.props.user}
                order={this.props.order}
                orderStatuses={this.props.orderStatuses}
                setRefreshToFalse={this.props.setRefreshToFalse}
                setRefreshToTrue={this.props.setRefreshToTrue}
                //isAdmin={this.props.isAdmin} 
                algoliaUser={this.props.algoliaUser} />

        const projectInfo = <CheckOrderProjectInfo
            user={this.props.user}
            order={this.props.order}
            orderStatuses={this.props.orderStatuses}
            algoliaUser={this.props.algoliaUser}
            searchNow={this.props.searchNow} />

        const viewReplacement = this.props.order.replacementOrderNumber

            ? <div>
                <br />
                <Icon color='red' disabled name='repeat' />
                <Link to={'/dashboard/SingleOrderViewAlgolia/' + this.props.order.replacementOrderNumber} target="_blank">VIEW REPLACEMENT - {this.props.order.replacementOrderNumber}</Link>
            </div>
            : ''

        const viewOriginal = this.props.order.replacementOf_order
            ? <div>
                <br />
                <Icon color='red' disabled name='repeat' />
                <Link to={'/dashboard/SingleOrderViewAlgolia/' + this.props.order.replacementOf_order} target="_blank">VIEW ORIGINAL - {this.props.order.replacementOf_order}</Link>
            </div>
            : ''

        //     const autoClientReviewToFollowUp = this.props.order.clnt_chckng_dsgn_moved_to_follow_up && this.props.order.status == Status.follow_up
        //         ? <div>
        //             <br />
        //             <Header as='h4'>
        //                 <Icon name='eye' />
        //                 <Header.Content>
        //                     Moved to Follow Up By System
        //   <Header.Subheader>{this.props.order.clnt_chckng_dsgn_rmndr_sent}</Header.Subheader>
        //                 </Header.Content>
        //             </Header>
        //         </div>
        //         : ''

        const systemAutoMove = this.props.order.statusChangeBySystemTo
            ? <div>
                Moved to {this.props.order.statusChangeBySystemTo} By System - {this.props.order.statusChangeBySystemTo_on}
                {/* <Header as='h4'>
                    <Icon name='eye' />
                    <Header.Content>
                        Moved to {this.props.order.statusChangeBySystemTo} By System
      <Header.Subheader>{this.props.order.statusChangeBySystemTo_on}</Header.Subheader>
                    </Header.Content>
                </Header> */}
            </div>
            : ''

        //     const autoFollowUpToLost = this.props.order.follow_up_moved_to_lost && this.props.order.status == Status.lost
        //         ? <div>
        //             <br />
        //             <Header as='h4'>
        //                 <Icon name='trash' />
        //                 <Header.Content>
        //                     Moved to Lost Up By System
        //   <Header.Subheader>{this.props.order.follow_up_rmndr_sent_dateTime}</Header.Subheader>
        //                 </Header.Content>
        //             </Header>
        //         </div>
        //         : ''

        const rejectedImage = this.props.order.whatsapp_clnt_rejectd_dsgn_image && this.props.order.whatsapp_clnt_rejectd_dsgn_image !== 'none' && this.props.order.status == Status.clnt_rejectd_dsgn
            ? <Image src={this.props.order.whatsapp_clnt_rejectd_dsgn_image} fluid />
            : ''

        const rejectedFeedback = this.props.order.whatsapp_clnt_rejectd_dsgn_rejectMssage && this.props.order.status == Status.clnt_rejectd_dsgn
            ? <div>
                <Divider>{'CLIENT REJECTED COMMENT'}</Divider>
                <Header as='h4' color='red'>
                    {this.props.order.whatsapp_clnt_rejectd_dsgn_rejectMssage}
                </Header>
                {rejectedImage}
            </div>
            : ''


        //const viewWhatsapConvoButton = this.props.algoliaUser && !this.props.searchNow
        const viewWhatsapConvoButton = this.props.algoliaUser
            ? <WhatsappGotoConvo
                user={this.props.user}
                order={this.props.order}
                //isAdmin={this.props.isAdmin} 
                algoliaUser={this.props.algoliaUser} />
            : ''

        const pendingOrderLoop = this.props.order.pendingOrders && this.props.order.pendingOrders.length > 0
            ? this.props.order.pendingOrders.map((order) =>
                <div>
                    <Feed.Event>
                        <Feed.Content>
                            <Feed.Summary>
                                <Feed.User> <Link to={'/dashboard/singleOrderView/' + order.order_num} target="_blank">{order.order_num} </Link></Feed.User> {order.itemtype}
                                {/* <Feed.Date>{order.dateEntered}</Feed.Date> */}
                            </Feed.Summary>
                            <Feed.Summary>{order.status}</Feed.Summary>
                        </Feed.Content>
                    </Feed.Event>
                    <Divider />
                </div>
            )
            : ''

        const pendingOrderUI = this.props.order.pendingOrders && this.props.order.pendingOrders.length > 0
            ? <Feed>
                {pendingOrderLoop}
            </Feed>
            : ''

        const WhatsappClntRevSendDepReqUI = !this.props.searchNow && this.props.order.status == Status.clnt_apprvd_dsgn
            ? <WhatsappClntRevSendDepReq
                user={this.props.user}
                order={this.props.order}
                //isAdmin={this.props.isAdmin} 
                algoliaUser={this.props.algoliaUser} />
            : ''

        //HEAT PRESS OR VINYL
        const depositReminderWhatsapp = this.props.order.status === Status.deposit_requested
            ? <WhatsappDepReqSendLost
                user={this.props.user}
                order={this.props.order}
                algoliaUser={this.props.algoliaUser} />
            : ''
        // const whatsAppAproval = <WhatsappPermission 
        //     user={this.props.user}
        //     order={this.props.order}
        //     orderStatuses={this.props.orderStatuses}
        //     //isAdmin={this.props.isAdmin} 
        //     algoliaUser={this.props.algoliaUser} />

        // const sendDesignViaWhatsapUi = !this.props.order.whatsApp_avail
        //     ? ''
        //     : <WhatsappSendImage
        //         user={this.props.user}
        //         order={this.props.order}
        //         //isAdmin={this.props.isAdmin} 
        //         algoliaUser={this.props.algoliaUser} />

        const sendDesignViaWhatsapUi = <WhatsappSendImage
            user={this.props.user}
            order={this.props.order}
            //isAdmin={this.props.isAdmin} 
            algoliaUser={this.props.algoliaUser}
            searchNow={this.props.searchNow} />

        const whatsappAvailUI = !this.props.order.whatsApp_avail
            ? <Header as='h4' icon>
                <Icon color='red' name='whatsapp square' />
                Whatsapp Not Avail
        </Header>
            : <Header as='h4' icon>
                <Icon color='green' name='whatsapp' />
                Whatsapp  Avail
        </Header>

        const viewFirebaseOrderUI = this.props.algoliaUser && this.props.algoliaUser.perms && this.props.algoliaUser.perms.includes("viewFirebaseOrder")
            ? <p>
                <div>
                    <a href={'https://console.firebase.google.com/u/0/project/printb-3daaa/database/printb-3daaa/data~2Forders~2F' + getOrderKey(this.props.order)} target="_blank">FIREBASE</a>
                    <CopyToClipboard text={getOrderKey(this.props.order)}
                        onCopy={() => this.setState({ copied: true })}>
                        <Button color='brown'>COPY FB LINK</Button>
                    </CopyToClipboard>
                </div>
            </p>
            : ''

        //const largeProjectItemOptions = this.state.algoliaUser && this.state.algoliaUser.isAdmin && this.props.order.idlargeProjectItem
        const largeProjectItemOptions = this.props.order.idlargeProjectItem
            ? <ViewItemOptionsInOrder user={this.props.user} largeProjectItemId={this.props.order.idlargeProjectItem} />
            : ''

         const setToOutForDeliveryUI = this.props.algoliaUser && this.props.algoliaUser.perms && this.props.algoliaUser.perms.includes("setToOutForDelivery")   
         ? <SetToOutForDelivery
            order={this.props.order}
            user={this.props.user}
            algoliaUser={this.props.algoliaUser} />
        : ""

        // const showEmbroidery = this.props.order.embroidery && this.props.order.embroidery == 'embroidery'
        //     ? <MarkEmbroidery
        //         order={this.props.order}
        //         user={this.props.user}
        //         algoliaUser={this.props.algoliaUser}
        //     />
        //     : ''

        return (
            <Card>
                {currentDesignImagePreview}
                {showDesignImageButton}
                {bringOrderFromArchivesButton}

                <Card.Content>
                    <Card.Header>#{this.props.order.order_num}-{this.props.order.name}</Card.Header>
                    {enteredBy}
                    {archivedOrder}
                    <GetTimeAgo dateNum={this.props.order.dateNum} />
                    {/* <p>{this.props.user.email}</p> */}

                    <ShowLastUpdate order={this.props.order} />
                    <br />

                    {/* ORDER TYPE */}
                    <ShowType order={this.props.order} />
                    <br />

                    <OrderStatus status={this.props.order.status} />


                    {/* AUTOMATICALLY MOVED ORDERS */}
                    {/* {autoClientReviewToFollowUp} */}
                    <br />
                    {systemAutoMove}
                    {/* {autoFollowUpToLost} */}

                    {/* LINK TO REPLACEMENT ORDER */}

                    {viewReplacement}

                    {/* LINK TO REPLACEMENT ORDER */}

                    {viewOriginal}

                    {/* SEND ORDER TO DEPOSIT REQUESTED */}
                    {depositRequestedStatus}

                    {/* SEND ORDER TO DEPOSIT REQUESTED */}
                    {/* {startKimotoDesign} */}

                    {/* SEND ORDER TO CLIENT REJECTED */}
                    {/* {sendToClientRejected} */}


                    {/* show if repl order has been made */}
                    {/* <ShowCranesReplacement order={this.props.order} /> */}

                    <SendToFindShirt
                        order={this.props.order}
                        sendToFindShirt={this.sendToFindShirt} />

                    <br />
                    <SendToConfirmOrder
                        order={this.props.order}
                        sendToConfirmOrder={this.sendToConfirmOrder} />

                    {/* SEND TO FOLLOW UP STATUS */}
                    {/* {updateStatusToFollowUp} */}

                    {/* UPDATE COUNTRY TO S SUDAN */}
                    {/* {updateCountryUI} */}

                    <br />
                    <MarkOrderAsDeliveredComponent
                        order={this.props.order}
                        markAsDelivered={this.markAsDelivered} />


                    {/* IF CLIENT REJECTS ORDER THEMSELVES FEEDBACK IS HERE */}
                    {rejectedReason}

                    {searchNowOrderUpdates}

                    {/* <OrderUpdateFeed
                            order={this.props.order}
                            searchNow={this.props.searchNow}
                            showUpdates={this.state.showUpdates}
                            orderUpdates={this.state.orderUpdatesbase}
                            syncOrderUpdates={this.syncOrderUpdates}
                            showComments={this.showComments} /> */}

                    {/* ADD COMMENT */}
                    {/* {updateOrderUI} */}
                    <UpdateComment
                        updateCommentFormSubmit={this.updateCommentFormSubmit}
                        textValue={this.state.updateText}
                        handleTextChange={this.handleTextChange} />

                    {/* WHATSAPP SECTION */}

                    <ShowOrderDetailsSection
                        order={this.props.order}
                        viewOrderDetails={this.state.viewOrderDetails}
                        viewOrderDetailsToggle={this.viewOrderDetailsToggle} />

                    <br />
                    {whatsAppButtons}

                    {setSalesPerson}

                    {/* SET USER DETAILS TYPE BY IVAN FOR ANALYTICS */}
                    {/* {setUserDetails} */}

                    {/* DELETE DUPLICATE ORDERS BUTTON */}
                    {deleteDuplicateOrderUI}

                    {/* ADD COMMENT */}
                    {/* {archiveOrder} */}

                    {/* mark as total loss */}
                    {/* {UpdateStatusTotalLoss} */}

                    {/* mark as STUCK */}
                    {/* {UpdateStatusStuck} */}

                    {/* Uupdat CRANES NUMBER */}
                    {/* <Card.Content extra>
                        <EnterCranesNumber
                            order={this.props.order}
                            cranesNumber={this.state.cranesNumber}
                            handleTextChange={this.handleCranseNumberTextChange}
                            updateCranesNumber={this.updateCranesNumber} />
                    </Card.Content> */}


                    {/* VIEW ORDER DETAILS */}

                    {/* <CardOrderDetails order={this.props.order} /> */}

                    {/* NEW VIEW FOR NEW SINGLE ORDERS */}
                    {viewSingleOrdersUi}
                    {/* <ViewSingleOrders
                        mainOrder={this.props.order}
                        user={this.props.user}
                        viewOrderDetails={this.state.viewOrderDetails}
                        viewOrderDetailsToggle={this.viewOrderDetailsToggle} /> */}
                    <br />

                    {/* NEW VIEW TO UPLOAD IMAGENOTES */}
                    {/* <ImageNoteUpload
                        mainOrder={this.props.order}
                        user={this.props.user} /> */}

                    {/* view order design button */}
                    <br />
                    <a href={'https://printboda.com/dashboard/imageNotes/' + this.props.order.key} target="_blank">VIEW IMAGE NOTES</a>

                    {/* NEW ORDER */}
                    {/* <VerifyOrderButton order={this.props.order} /> */}

                    {/* BUTTON FOR NEXT STATUS */}
                    <NextStatusButton
                        user={this.props.user}
                        order={this.props.order} />
                    <br />

                    {/* update status button*/}
                    {updateStatusAlgolia}
                    {/* <UpdateStatusAlgolia
                        user={this.props.user}
                        order={this.props.order}
                        orderStatuses={this.props.orderStatuses}
                        setRefreshToFalse={this.props.setRefreshToFalse}
                        setRefreshToTrue={this.props.setRefreshToTrue}
                        //isAdmin={this.props.isAdmin} 
                        algoliaUser={this.props.algoliaUser} /> */}

                    {/* CUSTOMER REJECTED DESIGNS BUTTON */}
                    <br />
                    <CustomerRejectDesigns
                        order={this.props.order}
                        clientRejectDesignFunction={this.clientRejectDesign} />

                    <MarkAutoSendDesign
                        order={this.props.order}
                        user={this.props.user}
                        algoliaUser={this.props.algoliaUser} />

                    {/* EMBROIDERY */}
                    <MarkEmbroidery
                        order={this.props.order}
                        user={this.props.user}
                        algoliaUser={this.props.algoliaUser} />

                    {/* SEND WHATS APP IMAGE */}
                    {sendDesignViaWhatsapUi}


                    {/* UPLOAD DESIGN BUTTON */}
                    <UploadDesign
                        designUploadComplete={this.designUploadComplete}
                        order={this.props.order}
                        user={this.props.user} />

                    {/* SHOW CONNECTED ORDERS LINK */}
                    {/* <Button color='yellow'>
                        <Link to={'/dashboard/connectedOrders/' + this.props.order.phone}>OTHER ORDERS</Link>
                    </Button> */}


                    {/* view order design button */}
                    <ViewOrderLink order={this.props.order} />

                    {/* <CopyOrderLink order={this.props.order} />
                    <br /> */}
                    {/* edit order button */}
                    {/* <EditOrderLink order={this.props.order} /> */}

                    {/* DUPLICATE ORDER */}
                    <DuplicateOrder
                        authed={this.state.authed}
                        user={this.props.user}
                        orderId={this.props.order.key}
                        order={this.props.order} />

                    <ReplacementOrder
                        authed={this.state.authed}
                        user={this.props.user}
                        orderId={getOrderKey(this.props.order)}
                        order={this.props.order}
                        searchNow={this.props.searchNow} />


                    {/* KIMOTO STUFF */}
                    <Kimoto user={this.props.user} order={this.props.order} />

                    {/* <LostButton order={this.props.order} makeOrderLost={this.makeOrderLost} /> */}

                    {/* IN HOUSE STOCK STUFF */}
                    <InHouseStockItem
                        user={this.props.user}
                        order={this.props.order}
                        algoliaUser={this.props.algoliaUser}
                    />

                    {/* SEND ORDER TO OUT FOR DELIVERY */}
                    {setToOutForDeliveryUI}

                    <ItemCostUI order={this.props.order} />

                    <EnterShirtCost order={this.props.order} user={this.props.user} />

                    {/* PROJECT INFO */}
                    {projectInfo}

                    {/* VIEW ITEM OPTIONS*/}
                    {largeProjectItemOptions}

                    {/* <MakeOrderLost order={this.props.order} user={this.props.user} /> */}

                    {/* KIMOTO STUFF */}
                    <DesignBackup user={this.props.user} order={this.props.order} />

                    {/* ATTACH A DESIGNER TO THIS ORDER */}
                    <PickDesigner order={this.props.order} user={this.props.user} designers={this.props.designers} />

                    {/* SEND ORDER TO REQUEST DEPOSIT */}
                    {/* {requestDepositStatus} */}
                    {depositConfirmation}


                    {/* REQUEST DEPOSIT DOESN'T SHOW WHEN PAST FIND SHIRT */}
                    {/* <RequestDeposit
                        user={this.props.user}
                        order={this.props.order}
                        searchNow={this.props.searchNow}
                        setRefreshToFalse={this.props.setRefreshToFalse}
                        setRefreshToTrue={this.props.setRefreshToTrue}
                        refresh={this.props.refresh} /> */}



                </Card.Content>

                {/* <Card.Content extra>
                    <MarkNumbersChecked order={this.props.order} markNumbersChecked={this.markNumbersChecked} />
                    <ShowNumChecked order={this.props.order}/>
                </Card.Content> */}


                {/* <DateRequired
                    admin={this.state.authed}
                    user={this.props.user}
                    order={this.props.order}
                    orderId={this.props.order.key} /> */}

                <Button color='yellow'><a href={'https://printboda.com/dashboard/connectedOrders/' + this.props.order.phone} target="_blank">OTHER ORDERS</a></Button>


                {/* SHOWS ORDER KEY*/}
                <Card.Content extra>
                    {this.props.order.key}
                    {this.props.order.objectID}
                </Card.Content>

                {/* SHOWS USER IMAGE*/}
                {userUploadedImage}
                {/* {showUserImageButton} */}

                {/* DELIVERY PERSON */}
                {/* <DeliveryPerson
                    deliveryPeople={this.props.deliveryPeople}
                    order={this.props.order} /> */}

                {/* {orderCallAction} */}

                {/* <CustomerPick
                    user={this.props.user}
                    order={this.props.order} /> */}

                {/* IVAN IVN IVAN */}
                {confirmReminderSms}

                <Divider horizontal>{'PENDING ORDERS'}</Divider>
                {pendingOrderUI}


                <Divider horizontal>{' Whatsapp'}</Divider>
                {/* SEND first whatsapp approval*/}

                {/* SEND to dpe requested send whatsapp*/}
                {WhatsappClntRevSendDepReqUI}
                <br />

                {/* SEND to LOST send whatsapp*/}
                {depositReminderWhatsapp}
                <br />

                {viewWhatsapConvoButton}

                <WhatsappPermission
                    user={this.props.user}
                    order={this.props.order}
                    //isAdmin={this.props.isAdmin} 
                    algoliaUser={this.props.algoliaUser} />

                <br />
                {/* UPDATE WHATSAPP PHONE*/}
                <WhatsappUpdatePhone
                    user={this.props.user}
                    order={this.props.order}
                    //isAdmin={this.props.isAdmin} 
                    algoliaUser={this.props.algoliaUser} />


                {/* SEND WHATS APP IMAGE */}
                {whatsappAvailUI}

                {/* <WhatsappSendImage
                    user={this.props.user}
                    order={this.props.order}
                    //isAdmin={this.props.isAdmin} 
                    algoliaUser={this.props.algoliaUser} /> */}

                {rejectedFeedback}

                {sendDeliveryGuySMS}

                {feedbackUI}
                {feedbackUIStuff}
                {viewFirebaseOrderUI}
            </Card>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/OrderCard.js